import React from 'react';

const containerStyles = {
  height: 50,
  marginBottom: '1rem',
  position: 'relative',
  width: '100%',
};

const bannerStyles = {
  backgroundColor: '#d0021b',
  color: '#FFF',
  fontSize: '1.15rem',
  fontWeight: '500',
  margin: 0,
  opacity: '0.75',
  padding: '1rem',
  paddingLeft: 150, // Account for left-hand navigation
  position: 'absolute',
  textAlign: 'center',
  top: 0,
  width: '100%',
};

const RunAsBanner = () => (
  <div style={containerStyles}>
    <p role="banner" style={bannerStyles}>
      You're currently browsing Moderation in Run-As mode.
    </p>
  </div>
);

export default RunAsBanner;



// WEBPACK FOOTER //
// ./src/pages/__components__/RunAsBanner.js